export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6554.e652fefd.jpg";